import { gsap } from "gsap";

export default class LoadingManager {
  constructor() {
    this.overlay = document.querySelector(".loading-overlay");
    this.loadingTexts = document.querySelectorAll(".loading-text");
    this.isComplete = false;

    this.init();
  }

  init() {
    // Start the loading text animation
    this.animateLoadingTexts();
  }

  animateLoadingTexts() {
    // Set initial state - all texts hidden
    gsap.set(this.loadingTexts, {
      opacity: 0,
      y: 30,
      scale: 0.9,
    });

    // Create timeline for entrance animation
    const entranceTl = gsap.timeline();

    // Animate each text appearing from top to bottom
    this.loadingTexts.forEach((text, index) => {
      entranceTl.to(
        text,
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: "back.out(1.7)",
        },
        index * 0.15
      ); // 150ms stagger
    });

    // After entrance is complete, wait a bit then start exit animation
    entranceTl.call(() => {
      setTimeout(() => {
        this.animateLoadingTextsExit();
      }, 800); // Wait 800ms after all texts have appeared
    });
  }

  animateLoadingTextsExit() {
    // Create timeline for exit animation
    const exitTl = gsap.timeline();

    // Animate each text disappearing from top to bottom
    this.loadingTexts.forEach((text, index) => {
      exitTl.to(
        text,
        {
          opacity: 0,
          y: -20,
          scale: 0.95,
          duration: 0.4,
          ease: "power2.in",
        },
        index * 0.1
      ); // 100ms stagger for exit
    });

    // After exit animation is complete, the loading can finish
    exitTl.call(() => {
      setTimeout(() => {
        // Allow some buffer time before completing
        if (!this.isComplete) {
          this.complete();
        }
      }, 200);
    });
  }

  complete() {
    this.isComplete = true;

    setTimeout(() => {
      this.hide();
    }, 800);
  }

  hide() {
    // Animate overlay pulling up like a curtain
    // The grid lines inside the overlay will move with it automatically
    gsap.to(this.overlay, {
      y: "-100%",
      duration: 1.2,
      ease: "power2.inOut",
      onComplete: () => {
        // Remove from DOM after animation
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
        }
      },
    });
  }
}
